import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CivilStatus } from '../../../models/civil-status.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { CivilStatusService } from '../../../services/civil-status/civil-status.service';

@Component({
  selector: 'app-civil-status',
  templateUrl: './civil-status.component.html',
  styleUrls: ['./civil-status.component.css']
})
export class CivilStatusComponent implements OnInit {

  civilStatusListTitles: DataTableField[];
  addEditDialog = false;
  dialogHeaderOptions: {insert: string, edit: string};
  // dialogHeader: string;
  modalTitle = '';
  labels = {};

  constructor(
    public civilStatusService: CivilStatusService,
    private srvDataTable: DataTableService,
    private translateService: TranslateService) {
    this.translateService.get(['civilStatusList']).subscribe((res) => {
      this.civilStatusListTitles = [
        {id: 'id', label: '#'},
        {id: 'name', label: res.civilStatusList.name},
        {id: 'description', label: res.civilStatusList.description}
      ];
      this.dialogHeaderOptions = {insert: res.civilStatusList.insert, edit: res.civilStatusList.edit}
    });
  }

  ngOnInit() {

    this.translateService.get([
      'civilStatusList.add_title',
      'civilStatusList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['civilStatusList.add_title'];
      this.labels['edit_title'] = res['civilStatusList.edit_title'];
    });

    this.reloadList();
  }

  reloadList() {
    this.civilStatusService.getList().subscribe();
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.civilStatusService.civilStatusEditing = data == null ? new CivilStatus() : data;
    this.addEditDialog = true;
  }

  closeAddDialog() {
    this.modalTitle = '';
    this.civilStatusService.civilStatusEditing = null;
    this.addEditDialog = false;
  }

  delete(record): void {
    this.civilStatusService.delete(record).subscribe(() => {
      this.reloadList();
    });
  }

  civilStatusAdded($event): void {
    this.civilStatusService.post($event).subscribe(() => {
      this.srvDataTable.get('dt_civil_status').showDetail = false;
      this.civilStatusService.civilStatusEditing = null;
      this.reloadList();
      this.addEditDialog = false;
    });
  }

  civilStatusUpdated($event): void {
    this.civilStatusService.put($event, this.civilStatusService.civilStatusEditing.id).subscribe(() => {
        this.srvDataTable.get('dt_civil_status').showDetail = false;
        this.civilStatusService.civilStatusEditing = null;
        this.reloadList();
        this.addEditDialog = false;
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/civil-status/civil-status.component.ts